// ======================================================================
// File Name       : ContentDocumentSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, InputGroup, Button, Row } from 'react-bootstrap';
import Datetime from 'react-datetime';
import SelectBox from '../../components/SelectBox';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import { DATA_AFFIILIATION_TYPE_STR } from '../../constants/ContentConstant';
import { onChangeWrapper } from '../../utils/FormUtils';
import { VALIDATE_TYPE } from '../../constants/index';
import FormControlValidate from '../FormControlValidate';
import RenderField from '../../utils/ReduxFormUtils';
import PaginationCustom from '../Pagination';
import ReduxFormPaging from '../ReduxFormPaging';
import CustomButton from '../button/CustomButton';
import * as Path from '../../constants/PathConstants';
import * as ICON from '../../constants/IconConstants';
import CustomLink from '../button/CustomLink';
import * as FUNCTION from '../../constants/FunctionConstants';
import { canAccessRoute } from '../../utils/AuthedUtils';

class ContentDocumentSearch extends React.Component {
  render() {
    const {
      contentSecernIds,
      contentName,
      documentUpdateStatus,
      createdDateFrom,
      createdDateTo,
      dataAffiliationType,
      onInputChange,
      onSearchBtnClick,
      recordNum,
      getStartEndData,
      openExportDialog,
      createdUserName, // Step 9.0.0
    } = this.props;
    const canAccessImport = canAccessRoute(FUNCTION.CONTENT_DOCUMENT_IMPORT);
    const canAccessRegister = canAccessRoute(FUNCTION.CONTENT_DOCUMENT_REGISTER);

    return (
      <Col sm={12} className="padding-left-right-clear">
        <h3>検索する項目を指定してください</h3>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            onSearchBtnClick();
          }}
          className='form-horizontal'
        >
          <Col sm={12} className="padding-top-10">
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                コンテンツ識別ID
              </Col>
              <Col sm={7}>
                <RenderField type="text" name="contentSecernIds" label="コンテンツ識別ID" value={contentSecernIds} />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                コンテンツ名
              </Col>
              <Col sm={7}>
                <RenderField type="text" name="contentName" label="コンテンツ名" value={contentName} />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                ステータス
              </Col>
              <Col sm={7}>
                <RenderField
                  type="selectbox"
                  name="documentUpdateStatus"
                  label="ステータス"
                  value={documentUpdateStatus}
                  data={SELECT_BOX_DATA.DOCUMENT_UPDATE_STATUS}
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col sm={3} as={Form.Label}>
                登録日
              </Col>
              <Col sm={3}>
                <RenderField
                  type="datetime"
                  name="createdDateFrom"
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                />
              </Col>
              <Col sm={1} className="text-center" as={Form.Label}>
                ～
              </Col>
              <Col sm={3}>
                <RenderField
                  type="datetime"
                  name="createdDateTo"
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                />
              </Col>
              <Col sm={12}>
                <RenderField
                  name="dateTimeMinMax"
                  type="dateTimeMinMax"
                  validates={[VALIDATE_TYPE.DATE_TIME_MIN_MAX]}
                  keyDateFrom={"createdDateFrom"}
                  keyDateTo={"createdDateTo"}
                />
              </Col>
            </Form.Group>
            {/* Step 9.0.0 START */}
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                登録者
              </Col>
              <Col sm={7}>
                <RenderField
                  type="text"
                  name='createdUserName'
                  label="登録者"
                  value={createdUserName}
                  maxLength={40} />
              </Col>
            </Form.Group>
            {/* Step 9.0.0 END */}
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                自サービス/外部
              </Col>
              <Col sm={9} className="padding-top-10">
                <RenderField
                  className="margin-left-30 padding-top-clear"
                  name="dataAffiliationType"
                  value={DATA_AFFIILIATION_TYPE_STR.NOT_SELECT}
                  type="radio"
                  label="選択なし"
                />

                <RenderField
                  className="margin-left-30 padding-top-clear"
                  name="dataAffiliationType"
                  value={DATA_AFFIILIATION_TYPE_STR.INTERNAL}
                  type="radio"
                  label="自サービスコンテンツ"
                />

                <RenderField
                  className="margin-left-30 padding-top-clear"
                  name="dataAffiliationType"
                  value={DATA_AFFIILIATION_TYPE_STR.EXTERNAL}
                  type="radio"
                  label="外部コンテンツ"
                />
              </Col>
            </Form.Group>
          </Col>
          <Form.Group className="text-center">
            <Col sm={12}>
              <CustomButton
                btnStyle="btn btn-primary btn-96 margin-top-20"
                type="submit"
                text="検索"
                iconClass="bi bi-search"
              />
            </Col>
          </Form.Group>
          <Form.Group>
            <Row className="margin-bottom-15">
              <Col sm={9} className="inline-flex">
                {canAccessRegister && (
                  <CustomLink
                    className="margin-right-7 btn-register margin-right-10"
                    to={Path.CONTENT_DOCUMENT_REGISTER}
                    text="ドキュメント追加"
                    icon={ICON.REGIST}
                  />
                )}
                {canAccessImport && (
                  <CustomLink
                    className="margin-right-7 btn-csv-import"
                    to={Path.CONTENT_DOCUMENT_IMPORT}
                    text="CSV一括投入"
                    icon={ICON.IMPORT}
                  />
                )}
              </Col>
              <Col sm={3}>
                <CustomButton
                  btnStyle="btn btn-export-csv float-end"
                  handleClick={openExportDialog}
                  iconClass="bi bi-download"
                  text="一括出力"
                />
              </Col>
            </Row>
          </Form.Group>
        </Form>
      </Col>
    );
  }
}

export default ContentDocumentSearch;
